import React, { useEffect, useState } from "react";
import "./adminStyles.css";
import dash_top_img from "../../assets/admin/dash_top_img.webp";
import dash_top_img2 from "../../assets/admin/dash_top_img2.webp";
import dash_top_img3 from "../../assets/admin/dash_top_img3.webp";
import { BsGlobe2 } from "react-icons/bs";
import AdminSidebar from "./Sidebar/AdminSidebar";
import AdminHeader from "./Header/AdminHeader";

import { getMethod, postMethod } from "../../core/service/common.api";
import apiService from "../../core/service/detail";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import moment from "moment";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from "@mui/material/Skeleton";

const AdminDashboard = () => {
  //login History
  const [loginData, setloginData] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [TotalUsers, setTotalUsers] = useState(0);
  const [TotalAssets, setTotalAssets] = useState(0);
  const [issuerCount, setTotalissuers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getLoginHistory();
    getuserCount();
    getissuerCount();
  }, [0]);

  const getuserCount = async () => {
    try {
      setLoader(true);
      var data = {
        apiUrl: apiService.userCount,
      };
      var resp = await postMethod(data);
      setLoader(false);
      if (resp.status == true) {
        setTotalUsers(resp.totalusers);
        setTotalAssets(resp.totalassest);
      } else {
        setTotalUsers(0);
      }
    } catch (err) {}
  };
  const getLoginHistory = async () => {
    try {
      var loginHisObj = {
        page: currentPage,
        perpage: 5,
      };
      setLoader(true);
      var data = {
        apiUrl: apiService.loginAdminHistory,
        payload: loginHisObj,
      };
      var resp = await postMethod(data);
      setLoader(false);
      if (resp.status == true) {
        setloginData(resp.data);
        setTotalPages(resp.totalPages);
      } else {
        setloginData([]);
      }
    } catch (err) {
      console.log(err, "=-==-");
    }
  };
  const getissuerCount = async () => {
    try {
      setLoader(true);
      var data = {
        apiUrl: apiService.issuerCount,
      };
      var resp = await postMethod(data);
      setLoader(false);
      if (resp.status == true) {
        setTotalissuers(resp.totalusers);
      } else {
        setTotalissuers(0);
      }
    } catch (err) {}
  };

  useEffect(() => {
    getLoginHistory();
  }, [currentPage]);

  const handlePageClick = (data) => {
    console.log(data, "data  ");
    setCurrentPage(data);
    // getLoginHistory();
  };

  // const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  //   const [windowStart, setWindowStart] = useState(1);
  //   const windowSize = 3;

  //   useEffect(() => {
  //     // Adjust window if currentPage moves outside the visible range
  //     if (currentPage < windowStart) {
  //       setWindowStart(currentPage);
  //     } else if (currentPage >= windowStart + windowSize) {
  //       setWindowStart(currentPage - windowSize + 1);
  //     }
  //   }, [currentPage]);

  //   const renderPageButtons = () => {
  //     const pages = [];
  //     const windowEnd = Math.min(windowStart + windowSize - 1, totalPages);

  //     for (let i = windowStart; i <= windowEnd; i++) {
  //       pages.push(
  //         <li key={i} className={`page-item ${currentPage === i ? "active" : ""}`}>
  //           <button className="page-link" onClick={() => onPageChange(i)}>
  //             {i}
  //           </button>
  //         </li>
  //       );
  //     }

  //     return pages;
  //   };

  //   const handlePrevWindow = () => {
  //     if (windowStart > 1) {
  //       const newStart = Math.max(windowStart - windowSize, 1);
  //       setWindowStart(newStart);
  //       onPageChange(newStart);
  //     }
  //   };

  //   const handleNextWindow = () => {
  //     if (windowStart + windowSize <= totalPages) {
  //       const newStart = windowStart + windowSize;
  //       setWindowStart(newStart);
  //       onPageChange(newStart);
  //     }
  //   };

  //   return (
  //     <nav aria-label="Page navigation example">
  //       <ul className="pagination custom_pagination">
  //         <li className={`page-item ${windowStart === 1 ? "disabled" : ""}`}>
  //           <button className="page-link" onClick={handlePrevWindow}>
  //             <FaArrowLeft />
  //           </button>
  //         </li>

  //         {renderPageButtons()}

  //         <li
  //           className={`page-item ${windowStart + windowSize > totalPages ? "disabled" : ""
  //             }`}
  //         >
  //           <button className="page-link" onClick={handleNextWindow}>
  //             <FaArrowRight />
  //           </button>
  //         </li>
  //       </ul>
  //     </nav>
  //   );
  // };

  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const [windowStart, setWindowStart] = useState(currentPage);
    const windowSize = 3;

    useEffect(() => {
      // Adjust window if currentPage moves outside the visible range
      if (currentPage < windowStart) {
        setWindowStart(currentPage);
      } else if (currentPage >= windowStart + windowSize) {
        setWindowStart(currentPage - windowSize + 1);
      }
    }, [currentPage]);

    const renderPageButtons = () => {
      return (
        <ul className="page_num_wrp">
          {windowStart > 1 ? (
            <li key={windowStart - 1} className={`page-item`}>
              <button
                className="page-link"
                onClick={() => onPageChange(windowStart - 1)}
              >
                {windowStart - 1}
              </button>
            </li>
          ) : null}
          <li
            key={windowStart}
            className={`page-item ${
              currentPage === windowStart ? "active" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => onPageChange(windowStart)}
            >
              {windowStart}
            </button>
          </li>
          {windowStart < totalPages ? (
            <li key={windowStart + 1} className={`page-item`}>
              <button
                className="page-link"
                onClick={() => onPageChange(windowStart + 1)}
              >
                {windowStart + 1}
              </button>
            </li>
          ) : null}
        </ul>
      );
    };

    const handlePrevWindow = () => {
      if (windowStart > 1) {
        const newStart = Math.max(windowStart - 1);
        setWindowStart(newStart);
        onPageChange(newStart);
      }
    };

    const handleNextWindow = () => {
      if (windowStart <= totalPages) {
        const newStart = windowStart + 1;
        setWindowStart(newStart);
        onPageChange(newStart);
      }
    };

    return (
      <nav aria-label="Page navigation example">
        <ul className="pagination custom_pagination">
          <li className={`page-item ${windowStart === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={handlePrevWindow}>
              <FaArrowLeft />
            </button>
          </li>

          {renderPageButtons()}

          <li
            className={`page-item ${
              windowStart >= totalPages ? "disabled" : ""
            }`}
          >
            <button className="page-link" onClick={handleNextWindow}>
              <FaArrowRight />
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  return (
    <>
      <>
        <AdminHeader />

        <main className="main_flx">
          <AdminSidebar />

          <div className="right_wrap pb-4">
            <div>
              <div className="dash_top_card">
                <div className="dash_card_itm">
                  <img src={dash_top_img} />
                  <h1>Total Users</h1>

                  <h4>
                    {loader == true ? (
                      <>
                        <Skeleton variant="text" className="dsh_skl_txt" />
                      </>
                    ) : (
                      <> {TotalUsers}</>
                    )}
                  </h4>
                </div>
                <div className="dash_card_itm">
                  <img src={dash_top_img2} />
                  <h1>Asset Count</h1>
                  <h4>
                    {loader == true ? (
                      <>
                        <Skeleton variant="text" className="dsh_skl_txt" />
                      </>
                    ) : (
                      <> {TotalAssets}</>
                    )}
                  </h4>
                </div>
                <div className="dash_card_itm">
                  <img src={dash_top_img3} />
                  <h1>Issuer Count</h1>
                  <h4>
                    {loader == true ? (
                      <>
                        <Skeleton variant="text" className="dsh_skl_txt" />
                      </>
                    ) : (
                      <> {issuerCount}</>
                    )}
                  </h4>
                </div>
              </div>

              <div className="dash_table_wrp">
                <h5 className="mx-0">Login History</h5>

                {/* {loader == true ? (
                  <span className="loader_user">
                    <CircularProgress size={40} />
                  </span>
                ) : ( )}*/}
                <div className="table-respo dash_table_main table-common h-100">
                  <div className="table">
                    <div className="thead">
                      <div className="tr">
                        <span className="th">Date & Time</span>
                        <span className="th">IP Address</span>
                        <span className="th">Device</span>
                      </div>
                    </div>

                    {loader ? (
                      <>
                        <div className="tbody">
                          {Array.from({ length: 5 }).map((_, index) => (
                            <div className="tr" key={index}>
                              <span className="table_td td">
                                <Skeleton
                                  variant="text"
                                  className="table_skl_txt"
                                />
                              </span>
                              <span className="table_td td">
                                <Skeleton
                                  variant="text"
                                  className="table_skl_txt"
                                />
                              </span>
                              <span className="table_td td">
                                <Skeleton
                                  variant="text"
                                  className="table_skl_txt"
                                />
                              </span>
                            </div>
                          ))}
                        </div>

                        <div className="mt-4 d-flex align-items-center justify-content-center gap-3">
                          <Skeleton
                            variant="circular"
                            className="skl_pagination_icon"
                          />
                          <Skeleton
                            variant="circular"
                            className="skl_pagination_icon"
                          />
                          <Skeleton
                            variant="circular"
                            className="skl_pagination_icon"
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="tbody">
                          {loginData.length > 0 ? (
                            loginData.map((item, index) => {
                              return (
                                <div className="tr">
                                  <span className="table_td td">
                                    {moment(item.createdDate).format("lll")}
                                  </span>
                                  <span className="table_td td">
                                    {item.ipAddress}
                                  </span>
                                  <span className="table_td td">
                                    {item.browser} {item.OS}
                                  </span>
                                </div>
                              );
                            })
                          ) : (
                            <div className="tr">
                              <span className="table_td td">
                                {" "}
                                <div className="nodata_wrap">
                                  <img
                                    src={
                                      new URL(
                                        "../../assets/No-data.webp",
                                        import.meta.url
                                      )
                                    }
                                    alt=""
                                    className="no_data_img"
                                  />
                                  No record found
                                </div>
                              </span>
                            </div>
                          )}
                        </div>

                        {loginData.length > 0 ? (
                          <div className="paginationcss">
                            <Pagination
                              currentPage={currentPage}
                              totalPages={totalPages}
                              onPageChange={(page) => {
                                // console.log(page,'onPageChange');
                                handlePageClick(page);
                              }}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="dsh_footer_wrap">
              <Footer />
            </div> */}
          </div>
        </main>
      </>
    </>
  );
};

export default AdminDashboard;
